export default "__VITE_ASSET__e40e9fa0__"